<template>
    <el-dialog 
      :title="title"
      class="wechatEdit"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="550px"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      v-dialogDrag>
            <el-form ref="form" :rules="rules" :model="form" label-width="120px" v-loading="formLoading">
                <el-form-item label="所属老师" prop="adminId">
                        <el-select
                    v-model="form.adminId"
                    placeholder="请选择所属老师"
                    clearable
                    :filterable="addTypeList.length > 9 ? true : false"
                    :disabled="disableAdminChange"
                    style="width: 250px"
                >
                    <el-option
                        v-for="item in addTypeList"
                        :label="item.value"
                        :value="item.key"
                        :key="item.key"
                    ></el-option>
                </el-select>
                </el-form-item>
        <el-form-item label="微信号" prop="number">
          <el-input style="width: 250px;" placeholder="请输入微信号" v-model="form.number"></el-input>
        </el-form-item>
            <el-form-item label="是否企业微信" prop="isEnterprise">
                <el-switch active-text="是" inactive-text="否" v-model="form.isEnterprise"></el-switch>
            </el-form-item>
            <el-form-item label="是否启用" prop="isOpen">
                <el-switch active-text="是" inactive-text="否" v-model="form.isOpen"></el-switch>
            </el-form-item>
        </el-form>
        <div class="button">
            <el-button v-if="!isLoading" :disabled="isLoading" type="primary" @click="submitWechat">提交保存</el-button>
            <el-button type="primary" v-else disabled>提交中<i class="el-icon-loading"></i></el-button>
            <el-button @click="closeDialog">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { getAdminList } from '../../network/administrator'
import { GetAdminWeiXin, EditAdminWeixin } from '../../network/teacherWxNumber'
export default {
    name: 'HuihangAdminPcAddWechat',
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        editWxListId: {
            type: Number,
            default: null
        },
        // 是否禁止修改所属老师（用于个人中心入口）
        disableAdminChange: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                adminId:null,
                number: '',
                isEnterprise: false,
                isOpen: false,
                formLoading: false
            },
            rules: {
                adminId:[
                    { required: true, message: '请选择所属老师', trigger: 'blur' },
                ],
                number: [
                    { required: true, message: '请输入微信号', trigger: 'blur' },
                ],
                isEnterprise: [
                    { required: true, message: '请选择是否企业微信', trigger: 'blur' },
                ],
                isOpen: [
                    { required: true, message: '请选择是否启用', trigger: 'blur' },
                ]
            },
            addTypeList:[],
            title:'添加微信号'
        };
    },

    watch: {
        dialogVisible:{
            handler(newVal) {
                if(!newVal) return
                this.form = {
                    adminId:null,
                    number: '',
                    isEnterprise: false,
                    isOpen: false,
                    formLoading: false
                }
                if(newVal){
                    this.getAdminData()
                }
                if(this.isEdit){
                    this.title = '编辑微信号'
                    this.getDetail()
                }else{
                    this.title = '添加微信号'
                }
            },
            immediate: true,
            deep: true
        }
    },

    methods: {
        async getDetail(){
            let res = await GetAdminWeiXin(this.editWxListId)
            if(res.code == 1){
                this.form = res.result
            }
        },
        async getAdminData(){
            this.formLoading = true
            let data = {
                ids: [0],
                keyWord: "",
                pageSize: 500,
                adminTypeIds: []
            };
            this.addTypeList = []
            let res = await getAdminList(data)
            if(res.code == 1 && res.result){
                // 去重
                const uniqueIds = new Set();
                res.result.forEach(element => {
                    if(!uniqueIds.has(element.id)){
                        uniqueIds.add(element.id);
                        this.addTypeList.push({
                            key: element.id,
                            value: element.name
                        })
                    }
                });
                this.formLoading = false
            }else{
                this.formLoading = false
            }
            if(!this.isEdit){
                const AdminCache = sessionStorage.getItem('AdminCache') && JSON.parse(sessionStorage.getItem('AdminCache'))
                this.form.adminId = AdminCache.adminId
            }
            
            
        },
        async submitWechat() {
            if (this.isLoading) {
                return false;
            }
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    return false;
                } else {
                   if(this.isEdit){
                    this.$emit('editSubmitWechat', this.form)
                   }else{
                    this.$emit('submitWechat', this.form)
                   }
                }
            });
        },
       
        closeDialog() {
            this.form = {
                adminId:null,
                number: '',
                isEnterprise: false,
                isOpen: false,
                formLoading: false
            }
            this.resetFormFields()
            this.$emit('closeDialog')
        },
        resetFormFields() {
            this.form = {
                adminId:null,
                number: '',
                isEnterprise: false,
                isOpen: false
            }
        }
    },
};
</script>

<style lang="scss" scoped></style>